export enum EventType {
    WEBRTC,
    RTMP,
}

export enum EventTypeName {
    WEBRTC = 'interactive',
    RTMP = 'streaming',
}

export enum EventTypeRoute {
    WEBRTC_ROUTE = 'streaming',
    RTMP_ROUTE = 'broadcast',
}
